// <www.sharporator.com[readonly.file]> do not change the file or delete this line

import React from 'react'
/*
Example of calling the component from 'getConnectionTokenPresenter.jsx':

...
import EndpointsTestingComponent from './endpointsTestingComponent'
...

    <EndpointsTestingComponent
        connectionToken={connectionToken}
        onConnectionTokenPost={onConnectionTokenPost}
        onConnectionTokenClear={onConnectionTokenClear}
        {...props}
    />

*/
    export default
        function EndpointsTestingComponent(
        {
            connectionToken, // fetch result of '/Proxy/GetConnectionToken',
            // //------------------------------------------
            onConnectionTokenPost, // fetch '/Proxy/GetConnectionToken',
            // //------------------------------------------
            onConnectionTokenClear,
            // //------------------------------------------
            ...props
        }
        )
        {
            const [authTokenconnectionToken, setAuthTokenconnectionToken] = React.useState('')
            const [phoneNumberconnectionToken, setPhoneNumberconnectionToken] = React.useState('')
            const [merchantTerminalIDconnectionToken, setMerchantTerminalIDconnectionToken] = React.useState('')
            React.useEffect(() => {
                const str =
                    connectionToken === null || connectionToken === undefined
                    ? ""
                    : JSON.stringify(connectionToken, undefined, 2);

                document.getElementById("getConnectionTokenJsonId").innerHTML = str;
            }, [connectionToken])
            function listReferenceRender() {
                return (
                    <div className='container-lg'>
                        <a
                            href='current#'
                            onClick={(event) => {
                                event.preventDefault();
                                props.history.push('/endpoint-testing-list');
                            }}
                        >
                            testing components list
                        </a>
                    </div>
                )
            }
            function proxyGetConnectionTokenConnectionTokenTestingForm() {
                return (
                    <>
                        <hr/>
                        <hr/>
                        <fieldset className='container-lg'>
                            <legend>Input values for endpoint '<span style={{color: 'blue'}}>/api/Proxy/GetConnectionToken'</span></legend>
                            <p><span><b>Получение Token для настройки устройства</b></span></p>
                            <p><span><b>Server call</b></span></p>
                            <form className='form-group' onReset={()=>onConnectionTokenClear()} onSubmit={event => {
                                event.preventDefault()
                                if (!authTokenconnectionToken) {
                                    alert("'AuthToken' is required.")
                                    return
                                }
                                if (!phoneNumberconnectionToken) {
                                    alert("'PhoneNumber' is required.")
                                    return
                                }
                                if (!merchantTerminalIDconnectionToken) {
                                    alert("'MerchantTerminalID' is required.")
                                    return
                                }
                                onConnectionTokenPost({authToken: authTokenconnectionToken, phoneNumber: phoneNumberconnectionToken, merchantTerminalID: merchantTerminalIDconnectionToken})
                            }}>
                            <div style={{marginTop: 8}} className='card'>
                                <div className='card-body'>
                                    <p style={{marginTop: 10}}><b>Body object properties (InputView properties):</b></p>
                                        <div style={{marginTop: 16}}>
                                            <div  style={{marginTop: 0}}>
                                                <label htmlFor='authTokenconnectionTokenId' className='form-label'>AuthToken</label>
                                                <input type='text' id='authTokenconnectionTokenId' className='form-control' value={authTokenconnectionToken} onChange={event => setAuthTokenconnectionToken(event.target.value)}/>
                                                {!authTokenconnectionToken && (
                                                    <div style={{ color: '#D83A3A' }}>
                                                        The 'AuthToken' is required.
                                                    </div>
                                                )}
                                            </div>

                                            <div  style={{marginTop: 16}}>
                                                <label htmlFor='phoneNumberconnectionTokenId' className='form-label'>PhoneNumber</label>
                                                <input type='text' id='phoneNumberconnectionTokenId' className='form-control' value={phoneNumberconnectionToken} onChange={event => setPhoneNumberconnectionToken(event.target.value)}/>
                                                {!phoneNumberconnectionToken && (
                                                    <div style={{ color: '#D83A3A' }}>
                                                        The 'PhoneNumber' is required.
                                                    </div>
                                                )}
                                            </div>

                                            <div  style={{marginTop: 16}}>
                                                <label htmlFor='merchantTerminalIDconnectionTokenId' className='form-label'>MerchantTerminalID</label>
                                                <input type='text' id='merchantTerminalIDconnectionTokenId' className='form-control' value={merchantTerminalIDconnectionToken} onChange={event => setMerchantTerminalIDconnectionToken(event.target.value)}/>
                                                {!merchantTerminalIDconnectionToken && (
                                                    <div style={{ color: '#D83A3A' }}>
                                                        The 'MerchantTerminalID' is required.
                                                    </div>
                                                )}
                                            </div>

                                        </div>
                                    <input className='btn btn-primary' style={{marginTop: 24}} type = 'submit' value = 'Submit'/>
                                    <input className='btn' style={{marginTop: 24, marginLeft: 16}} type = 'reset' value = 'Clear'/>
                                </div>
                            </div>
                            </form>
                        </fieldset>
                        {proxyGetConnectionTokenConnectionTokenTestingResult()}
                    </>
                )
            }
            function proxyGetConnectionTokenConnectionTokenTestingResult() {
                return (
                    <>
                        <div style={{marginTop: 32}} className='container-lg'>
                            <p><b>Result of endpoint '<span style={{color: 'navy'}}>/api/Proxy/GetConnectionToken</span>':</b></p>
                            <span>{'--> string connectionToken'}</span>
                            <pre id="getConnectionTokenJsonId"></pre>
                        </div>
                    </>
                )
            }
            return (
                <>
                    {listReferenceRender()}
                    {proxyGetConnectionTokenConnectionTokenTestingForm()}
                </>
            )
        }
